<template>
  <b-form @submit.prevent="onSubmit" novalidate>
    <b-form-group label-for="input-name">
      <template #label>
        Name of your company or workspace*
      </template>
      <b-form-input id="input-name" v-model="form.name" :state="isValidField('name')" placeholder="eg., The Happy Company" class="rounded-pill" />
      <b-form-invalid-feedback :state="isValidField('name')">
        <div v-for="error in errors.name || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group label-for="input-email">
      <template #label>
        Email*
      </template>
      <b-form-input type="email" id="input-email" v-model="form.email" :state="isValidField('email')" placeholder="eg., name@company.com" class="rounded-pill" />
      <b-form-invalid-feedback :state="isValidField('email')">
        <div v-for="error in errors.email || []" :key="error">
          {{ error }}
        </div>
      </b-form-invalid-feedback>
    </b-form-group>
    <b-row class="align-items-center mt-3 mb-3">
      <b-col><div class="think-line" /></b-col>
      <b-col cols="auto">OR</b-col>
      <b-col><div class="think-line" /></b-col>
    </b-row>
    <b-form-group>
      <b-button :disabled="submitting" variant="outline-secondary" class="w-100" @click="onGoogleSubmit">
        <google-icon /> Sign up with Google
      </b-button>
    </b-form-group>
    <b-form-group class="pt-2 pb-3">
      By creating a Good4work workspace, I agree to Good4work's
      <b-link :href="urls.termsOfService" target="_blank" class="btn-link-primary">Terms of Service</b-link>
      and
      <b-link :href="urls.privacyPolicy" target="_blank" class="btn-link-primary">Privacy Policy</b-link>.
    </b-form-group>
    <b-button type="submit" :disabled="submitting" pill variant="primary" class="w-100">Confirm</b-button>
  </b-form>
</template>

<script>
import validator from 'validator'
import MixinForm from './MixinForm'
import GoogleIcon from '@/assets/images/google.svg'
import { termsOfServiceUrl, privacyPolicyUrl } from '@/helpers/external'

export default {
  name: 'CreateWorkspaceForm',

  mixins: [MixinForm],

  data() {
    return {
      form: {
        name: '',
        email: ''
      },
      urls: Object.freeze({
        termsOfService: termsOfServiceUrl,
        privacyPolicy: privacyPolicyUrl
      })
    }
  },

  methods: {
    validate(data) {
      const errors = {}
      if (!validator.isEmail(data.email)) errors.email = ['Email format is invalid']
      if (validator.isEmpty(data.name)) errors.name = ["Name of the workspace can't be blank"]
      return errors
    },

    validateGoogle(data) {
      const errors = {}
      if (validator.isEmpty(data.name)) errors.name = ["Name of the workspace can't be blank"]
      return errors
    },

    onGoogleSubmit() {
      this.errors = this.validateGoogle(this.form)
      if (this.isValid) {
        this.$emit('googlesubmit', this.form)
      }
    }
  },

  components: {
    GoogleIcon
  }
}
</script>
